var map = {
	"./LecturasCuarto/Sesion10/Lectura": [
		8581
	],
	"./LecturasCuarto/Sesion11/Lectura": [
		99024
	],
	"./LecturasCuarto/Sesion12/Lectura": [
		6859
	],
	"./LecturasCuarto/Sesion13/Lectura": [
		54214
	],
	"./LecturasCuarto/Sesion14/Lectura": [
		81145
	],
	"./LecturasCuarto/Sesion15/Lectura": [
		44612
	],
	"./LecturasCuarto/Sesion16/Lectura": [
		96735
	],
	"./LecturasCuarto/Sesion17/Lectura": [
		75706
	],
	"./LecturasCuarto/Sesion18/Lectura": [
		88429
	],
	"./LecturasCuarto/Sesion19/Lectura": [
		97016
	],
	"./LecturasCuarto/Sesion20/Lectura": [
		62900
	],
	"./LecturasCuarto/Sesion21/Lectura": [
		4297
	],
	"./LecturasCuarto/Sesion21R/Lectura": [
		28681
	],
	"./LecturasCuarto/Sesion22/Lectura": [
		40362
	],
	"./LecturasCuarto/Sesion23/Lectura": [
		66223
	],
	"./LecturasCuarto/Sesion24/Lectura": [
		16416
	],
	"./LecturasCuarto/Sesion25/Lectura": [
		78293
	],
	"./LecturasCuarto/Sesion26/Lectura": [
		56086
	],
	"./LecturasCuarto/Sesion27/Lectura": [
		55003
	],
	"./LecturasCuarto/Sesion28/Lectura": [
		9660
	],
	"./LecturasCuarto/Sesion29/Lectura": [
		96817
	],
	"./LecturasCuarto/Sesion3/Lectura": [
		9173
	],
	"./LecturasCuarto/Sesion30/Lectura": [
		34179
	],
	"./LecturasCuarto/Sesion31/Lectura": [
		82238
	],
	"./LecturasCuarto/Sesion32/Lectura": [
		2781
	],
	"./LecturasCuarto/Sesion33/Lectura": [
		49608
	],
	"./LecturasCuarto/Sesion34/Lectura": [
		93687
	],
	"./LecturasCuarto/Sesion35/Lectura": [
		74322
	],
	"./LecturasCuarto/Sesion36/Lectura": [
		62929
	],
	"./LecturasCuarto/Sesion37/Lectura": [
		23804
	],
	"./LecturasCuarto/Sesion38/Lectura": [
		69243
	],
	"./LecturasCuarto/Sesion39/Lectura": [
		95286
	],
	"./LecturasCuarto/Sesion39R/Lectura": [
		55584
	],
	"./LecturasCuarto/Sesion4/Lectura": [
		71242
	],
	"./LecturasCuarto/Sesion40/Lectura": [
		79650
	],
	"./LecturasCuarto/Sesion41/Lectura": [
		20775
	],
	"./LecturasCuarto/Sesion42/Lectura": [
		5900
	],
	"./LecturasCuarto/Sesion43/Lectura": [
		22881
	],
	"./LecturasCuarto/Sesion44/Lectura": [
		27054
	],
	"./LecturasCuarto/Sesion45/Lectura": [
		25875
	],
	"./LecturasCuarto/Sesion46/Lectura": [
		56920
	],
	"./LecturasCuarto/Sesion47/Lectura": [
		5453
	],
	"./LecturasCuarto/Sesion48/Lectura": [
		5786
	],
	"./LecturasCuarto/Sesion49/Lectura": [
		6335
	],
	"./LecturasCuarto/Sesion5/Lectura": [
		13455
	],
	"./LecturasCuarto/Sesion50/Lectura": [
		76817
	],
	"./LecturasCuarto/Sesion51/Lectura": [
		72668
	],
	"./LecturasCuarto/Sesion52/Lectura": [
		8791
	],
	"./LecturasCuarto/Sesion53/Lectura": [
		61458
	],
	"./LecturasCuarto/Sesion54/Lectura": [
		85597
	],
	"./LecturasCuarto/Sesion55/Lectura": [
		2568
	],
	"./LecturasCuarto/Sesion56/Lectura": [
		69731
	],
	"./LecturasCuarto/Sesion56R/Lectura": [
		60643
	],
	"./LecturasCuarto/Sesion57/Lectura": [
		77438
	],
	"./LecturasCuarto/Sesion58/Lectura": [
		63465
	],
	"./LecturasCuarto/Sesion6/Lectura": [
		93780
	],
	"./LecturasCuarto/Sesion7/Lectura": [
		35177
	],
	"./LecturasCuarto/Sesion8/Lectura": [
		28734
	],
	"./LecturasCuarto/Sesion9/Lectura": [
		63779
	],
	"./LecturasPrimero/Sesion10/Lectura": [
		14027
	],
	"./LecturasPrimero/Sesion11/Lectura": [
		46182
	],
	"./LecturasPrimero/Sesion12/Lectura": [
		82277
	],
	"./LecturasPrimero/Sesion13/Lectura": [
		41040
	],
	"./LecturasPrimero/Sesion14/Lectura": [
		42783
	],
	"./LecturasPrimero/Sesion15/Lectura": [
		42234
	],
	"./LecturasPrimero/Sesion16/Lectura": [
		93433
	],
	"./LecturasPrimero/Sesion17/Lectura": [
		52260
	],
	"./LecturasPrimero/Sesion18/Lectura": [
		45971
	],
	"./LecturasPrimero/Sesion19/Lectura": [
		63502
	],
	"./LecturasPrimero/Sesion20/Lectura": [
		51262
	],
	"./LecturasPrimero/Sesion21/Lectura": [
		86307
	],
	"./LecturasPrimero/Sesion21R/Lectura": [
		84099,
		84099
	],
	"./LecturasPrimero/Sesion22/Lectura": [
		6536
	],
	"./LecturasPrimero/Sesion23/Lectura": [
		6877
	],
	"./LecturasPrimero/Sesion24/Lectura": [
		4754
	],
	"./LecturasPrimero/Sesion25/Lectura": [
		24663
	],
	"./LecturasPrimero/Sesion26/Lectura": [
		63068
	],
	"./LecturasPrimero/Sesion27/Lectura": [
		50225
	],
	"./LecturasPrimero/Sesion28/Lectura": [
		9494
	],
	"./LecturasPrimero/Sesion29/Lectura": [
		8411
	],
	"./LecturasPrimero/Sesion3/Lectura": [
		23123
	],
	"./LecturasPrimero/Sesion30/Lectura": [
		63085
	],
	"./LecturasPrimero/Sesion31/Lectura": [
		54360
	],
	"./LecturasPrimero/Sesion32/Lectura": [
		5075
	],
	"./LecturasPrimero/Sesion33/Lectura": [
		42702
	],
	"./LecturasPrimero/Sesion34/Lectura": [
		1633
	],
	"./LecturasPrimero/Sesion35/Lectura": [
		20908
	],
	"./LecturasPrimero/Sesion36/Lectura": [
		43271
	],
	"./LecturasPrimero/Sesion37/Lectura": [
		34146
	],
	"./LecturasPrimero/Sesion38/Lectura": [
		1157
	],
	"./LecturasPrimero/Sesion39/Lectura": [
		11056
	],
	"./LecturasPrimero/Sesion39R/Lectura": [
		60762,
		60762
	],
	"./LecturasPrimero/Sesion4/Lectura": [
		21612
	],
	"./LecturasPrimero/Sesion40/Lectura": [
		72312
	],
	"./LecturasPrimero/Sesion41/Lectura": [
		47373
	],
	"./LecturasPrimero/Sesion42/Lectura": [
		49486
	],
	"./LecturasPrimero/Sesion43/Lectura": [
		35283
	],
	"./LecturasPrimero/Sesion44/Lectura": [
		33772
	],
	"./LecturasPrimero/Sesion45/Lectura": [
		31745
	],
	"./LecturasPrimero/Sesion46/Lectura": [
		31682
	],
	"./LecturasPrimero/Sesion47/Lectura": [
		87239
	],
	"./LecturasPrimero/Sesion48/Lectura": [
		57968
	],
	"./LecturasPrimero/Sesion49/Lectura": [
		67525
	],
	"./LecturasPrimero/Sesion5/Lectura": [
		19585
	],
	"./LecturasPrimero/Sesion50/Lectura": [
		30199
	],
	"./LecturasPrimero/Sesion51/Lectura": [
		26642
	],
	"./LecturasPrimero/Sesion52/Lectura": [
		55761
	],
	"./LecturasPrimero/Sesion53/Lectura": [
		84956
	],
	"./LecturasPrimero/Sesion54/Lectura": [
		91843
	],
	"./LecturasPrimero/Sesion55/Lectura": [
		56798
	],
	"./LecturasPrimero/Sesion56/Lectura": [
		12413
	],
	"./LecturasPrimero/Sesion56R/Lectura": [
		44757,
		44757
	],
	"./LecturasPrimero/Sesion57/Lectura": [
		12072
	],
	"./LecturasPrimero/Sesion58/Lectura": [
		41519
	],
	"./LecturasPrimero/Sesion59/Lectura": [
		99306,
		99306
	],
	"./LecturasPrimero/Sesion6/Lectura": [
		19522
	],
	"./LecturasPrimero/Sesion7/Lectura": [
		75079
	],
	"./LecturasPrimero/Sesion8/Lectura": [
		62160
	],
	"./LecturasPrimero/Sesion9/Lectura": [
		55365
	],
	"./LecturasQuinto/Sesion10/Lectura": [
		71927
	],
	"./LecturasQuinto/Sesion11/Lectura": [
		52018
	],
	"./LecturasQuinto/Sesion12/Lectura": [
		38641
	],
	"./LecturasQuinto/Sesion13/Lectura": [
		77308
	],
	"./LecturasQuinto/Sesion14/Lectura": [
		99171
	],
	"./LecturasQuinto/Sesion15/Lectura": [
		62462
	],
	"./LecturasQuinto/Sesion16/Lectura": [
		32349
	],
	"./LecturasQuinto/Sesion17/Lectura": [
		18696
	],
	"./LecturasQuinto/Sesion18/Lectura": [
		46415
	],
	"./LecturasQuinto/Sesion19/Lectura": [
		906
	],
	"./LecturasQuinto/Sesion20/Lectura": [
		17514
	],
	"./LecturasQuinto/Sesion21/Lectura": [
		78543
	],
	"./LecturasQuinto/Sesion21R/Lectura": [
		87415
	],
	"./LecturasQuinto/Sesion22/Lectura": [
		34804
	],
	"./LecturasQuinto/Sesion23/Lectura": [
		80169
	],
	"./LecturasQuinto/Sesion24/Lectura": [
		11734
	],
	"./LecturasQuinto/Sesion25/Lectura": [
		85691
	],
	"./LecturasQuinto/Sesion26/Lectura": [
		98688
	],
	"./LecturasQuinto/Sesion27/Lectura": [
		24437
	],
	"./LecturasQuinto/Sesion28/Lectura": [
		90770
	],
	"./LecturasQuinto/Sesion29/Lectura": [
		10135
	],
	"./LecturasQuinto/Sesion3/Lectura": [
		57735
	],
	"./LecturasQuinto/Sesion30/Lectura": [
		89785
	],
	"./LecturasQuinto/Sesion31/Lectura": [
		48612
	],
	"./LecturasQuinto/Sesion32/Lectura": [
		39135
	],
	"./LecturasQuinto/Sesion33/Lectura": [
		38586
	],
	"./LecturasQuinto/Sesion34/Lectura": [
		94981
	],
	"./LecturasQuinto/Sesion35/Lectura": [
		37392
	],
	"./LecturasQuinto/Sesion36/Lectura": [
		10379
	],
	"./LecturasQuinto/Sesion37/Lectura": [
		42534
	],
	"./LecturasQuinto/Sesion38/Lectura": [
		39329
	],
	"./LecturasQuinto/Sesion39/Lectura": [
		38700
	],
	"./LecturasQuinto/Sesion39R/Lectura": [
		49582
	],
	"./LecturasQuinto/Sesion4/Lectura": [
		77624
	],
	"./LecturasQuinto/Sesion40/Lectura": [
		75772
	],
	"./LecturasQuinto/Sesion41/Lectura": [
		46577
	],
	"./LecturasQuinto/Sesion42/Lectura": [
		17458
	],
	"./LecturasQuinto/Sesion43/Lectura": [
		21015
	],
	"./LecturasQuinto/Sesion44/Lectura": [
		2888
	],
	"./LecturasQuinto/Sesion45/Lectura": [
		3229
	],
	"./LecturasQuinto/Sesion46/Lectura": [
		47614
	],
	"./LecturasQuinto/Sesion47/Lectura": [
		82659
	],
	"./LecturasQuinto/Sesion48/Lectura": [
		12660
	],
	"./LecturasQuinto/Sesion49/Lectura": [
		54057
	],
	"./LecturasQuinto/Sesion5/Lectura": [
		18349
	],
	"./LecturasQuinto/Sesion50/Lectura": [
		85963
	],
	"./LecturasQuinto/Sesion51/Lectura": [
		38470
	],
	"./LecturasQuinto/Sesion52/Lectura": [
		97509
	],
	"./LecturasQuinto/Sesion53/Lectura": [
		7408
	],
	"./LecturasQuinto/Sesion54/Lectura": [
		71775
	],
	"./LecturasQuinto/Sesion55/Lectura": [
		94074
	],
	"./LecturasQuinto/Sesion56/Lectura": [
		82297
	],
	"./LecturasQuinto/Sesion56R/Lectura": [
		9497
	],
	"./LecturasQuinto/Sesion57/Lectura": [
		92388
	],
	"./LecturasQuinto/Sesion58/Lectura": [
		1427
	],
	"./LecturasQuinto/Sesion59/Lectura": [
		39054,
		39054
	],
	"./LecturasQuinto/Sesion6/Lectura": [
		20110
	],
	"./LecturasQuinto/Sesion7/Lectura": [
		37715
	],
	"./LecturasQuinto/Sesion8/Lectura": [
		44900
	],
	"./LecturasQuinto/Sesion9/Lectura": [
		59513
	],
	"./LecturasSegundo/Sesion10/Lectura": [
		24180
	],
	"./LecturasSegundo/Sesion11/Lectura": [
		65577
	],
	"./LecturasSegundo/Sesion12/Lectura": [
		85290
	],
	"./LecturasSegundo/Sesion13/Lectura": [
		27503
	],
	"./LecturasSegundo/Sesion14/Lectura": [
		77696
	],
	"./LecturasSegundo/Sesion15/Lectura": [
		39573
	],
	"./LecturasSegundo/Sesion16/Lectura": [
		17366
	],
	"./LecturasSegundo/Sesion17/Lectura": [
		16283
	],
	"./LecturasSegundo/Sesion18/Lectura": [
		70940
	],
	"./LecturasSegundo/Sesion19/Lectura": [
		58097
	],
	"./LecturasSegundo/Sesion20/Lectura": [
		69861,
		69861
	],
	"./LecturasSegundo/Sesion21/Lectura": [
		60304
	],
	"./LecturasSegundo/Sesion21R/Lectura": [
		94650,
		94650
	],
	"./LecturasSegundo/Sesion22/Lectura": [
		68139
	],
	"./LecturasSegundo/Sesion23/Lectura": [
		15494
	],
	"./LecturasSegundo/Sesion24/Lectura": [
		42425
	],
	"./LecturasSegundo/Sesion25/Lectura": [
		5892
	],
	"./LecturasSegundo/Sesion26/Lectura": [
		58015
	],
	"./LecturasSegundo/Sesion27/Lectura": [
		36986
	],
	"./LecturasSegundo/Sesion28/Lectura": [
		49709
	],
	"./LecturasSegundo/Sesion29/Lectura": [
		58296
	],
	"./LecturasSegundo/Sesion3/Lectura": [
		72726
	],
	"./LecturasSegundo/Sesion30/Lectura": [
		20886
	],
	"./LecturasSegundo/Sesion31/Lectura": [
		49019
	],
	"./LecturasSegundo/Sesion32/Lectura": [
		86848
	],
	"./LecturasSegundo/Sesion33/Lectura": [
		76597
	],
	"./LecturasSegundo/Sesion34/Lectura": [
		90538
	],
	"./LecturasSegundo/Sesion35/Lectura": [
		36047
	],
	"./LecturasSegundo/Sesion36/Lectura": [
		9172
	],
	"./LecturasSegundo/Sesion37/Lectura": [
		79369
	],
	"./LecturasSegundo/Sesion38/Lectura": [
		68446,
		68446
	],
	"./LecturasSegundo/Sesion39/Lectura": [
		5155
	],
	"./LecturasSegundo/Sesion39R/Lectura": [
		12899,
		12899
	],
	"./LecturasSegundo/Sesion4/Lectura": [
		20937
	],
	"./LecturasSegundo/Sesion40/Lectura": [
		41583
	],
	"./LecturasSegundo/Sesion41/Lectura": [
		12426
	],
	"./LecturasSegundo/Sesion42/Lectura": [
		84905
	],
	"./LecturasSegundo/Sesion43/Lectura": [
		14708
	],
	"./LecturasSegundo/Sesion44/Lectura": [
		54555
	],
	"./LecturasSegundo/Sesion45/Lectura": [
		42774
	],
	"./LecturasSegundo/Sesion46/Lectura": [
		82133
	],
	"./LecturasSegundo/Sesion47/Lectura": [
		8736
	],
	"./LecturasSegundo/Sesion48/Lectura": [
		83447
	],
	"./LecturasSegundo/Sesion49/Lectura": [
		63538
	],
	"./LecturasSegundo/Sesion5/Lectura": [
		79540
	],
	"./LecturasSegundo/Sesion50/Lectura": [
		58032
	],
	"./LecturasSegundo/Sesion51/Lectura": [
		31781
	],
	"./LecturasSegundo/Sesion52/Lectura": [
		94982
	],
	"./LecturasSegundo/Sesion53/Lectura": [
		14507
	],
	"./LecturasSegundo/Sesion54/Lectura": [
		85508
	],
	"./LecturasSegundo/Sesion55/Lectura": [
		83769,
		83769
	],
	"./LecturasSegundo/Sesion56/Lectura": [
		14970
	],
	"./LecturasSegundo/Sesion56R/Lectura": [
		64060,
		64060
	],
	"./LecturasSegundo/Sesion57/Lectura": [
		61695
	],
	"./LecturasSegundo/Sesion58/Lectura": [
		1880
	],
	"./LecturasSegundo/Sesion6/Lectura": [
		99215
	],
	"./LecturasSegundo/Sesion7/Lectura": [
		57002
	],
	"./LecturasSegundo/Sesion8/Lectura": [
		70109
	],
	"./LecturasSegundo/Sesion9/Lectura": [
		69768
	],
	"./LecturasSexto/Sesion10/Lectura": [
		43610
	],
	"./LecturasSexto/Sesion11/Lectura": [
		90335
	],
	"./LecturasSexto/Sesion12/Lectura": [
		14148
	],
	"./LecturasSexto/Sesion13/Lectura": [
		12409
	],
	"./LecturasSexto/Sesion14/Lectura": [
		23622
	],
	"./LecturasSexto/Sesion15/Lectura": [
		43147
	],
	"./LecturasSexto/Sesion16/Lectura": [
		86672
	],
	"./LecturasSexto/Sesion17/Lectura": [
		60421
	],
	"./LecturasSexto/Sesion18/Lectura": [
		14882
	],
	"./LecturasSexto/Sesion19/Lectura": [
		26983
	],
	"./LecturasSexto/Sesion20/Lectura": [
		18631
	],
	"./LecturasSexto/Sesion21/Lectura": [
		9506
	],
	"./LecturasSexto/Sesion21R/Lectura": [
		86100
	],
	"./LecturasSexto/Sesion22/Lectura": [
		76993
	],
	"./LecturasSexto/Sesion23/Lectura": [
		96268
	],
	"./LecturasSexto/Sesion24/Lectura": [
		64083
	],
	"./LecturasSexto/Sesion25/Lectura": [
		18062
	],
	"./LecturasSexto/Sesion26/Lectura": [
		38445
	],
	"./LecturasSexto/Sesion27/Lectura": [
		13368
	],
	"./LecturasSexto/Sesion28/Lectura": [
		50783
	],
	"./LecturasSexto/Sesion29/Lectura": [
		56730
	],
	"./LecturasSexto/Sesion3/Lectura": [
		62575
	],
	"./LecturasSexto/Sesion30/Lectura": [
		65544
	],
	"./LecturasSexto/Sesion31/Lectura": [
		82237
	],
	"./LecturasSexto/Sesion32/Lectura": [
		26622
	],
	"./LecturasSexto/Sesion33/Lectura": [
		61667
	],
	"./LecturasSexto/Sesion34/Lectura": [
		38428
	],
	"./LecturasSexto/Sesion35/Lectura": [
		25585
	],
	"./LecturasSexto/Sesion36/Lectura": [
		80114
	],
	"./LecturasSexto/Sesion37/Lectura": [
		23
	],
	"./LecturasSexto/Sesion38/Lectura": [
		45184
	],
	"./LecturasSexto/Sesion39/Lectura": [
		7061
	],
	"./LecturasSexto/Sesion39R/Lectura": [
		96349
	],
	"./LecturasSexto/Sesion4/Lectura": [
		65667
	],
	"./LecturasSexto/Sesion40/Lectura": [
		92701
	],
	"./LecturasSexto/Sesion41/Lectura": [
		39528
	],
	"./LecturasSexto/Sesion42/Lectura": [
		24099
	],
	"./LecturasSexto/Sesion43/Lectura": [
		72158
	],
	"./LecturasSexto/Sesion44/Lectura": [
		52849
	],
	"./LecturasSexto/Sesion45/Lectura": [
		13724
	],
	"./LecturasSexto/Sesion46/Lectura": [
		83607
	],
	"./LecturasSexto/Sesion47/Lectura": [
		64242
	],
	"./LecturasSexto/Sesion48/Lectura": [
		97909
	],
	"./LecturasSexto/Sesion49/Lectura": [
		55808
	],
	"./LecturasSexto/Sesion5/Lectura": [
		89726
	],
	"./LecturasSexto/Sesion50/Lectura": [
		12526
	],
	"./LecturasSexto/Sesion51/Lectura": [
		58547
	],
	"./LecturasSexto/Sesion52/Lectura": [
		7832
	],
	"./LecturasSexto/Sesion53/Lectura": [
		32909
	],
	"./LecturasSexto/Sesion54/Lectura": [
		87618
	],
	"./LecturasSexto/Sesion55/Lectura": [
		35476
	],
	"./LecturasSexto/Sesion56/Lectura": [
		90732
	],
	"./LecturasSexto/Sesion56R/Lectura": [
		81806
	],
	"./LecturasSexto/Sesion57/Lectura": [
		71457
	],
	"./LecturasSexto/Sesion58/Lectura": [
		95590
	],
	"./LecturasSexto/Sesion59/Lectura": [
		43083,
		43083
	],
	"./LecturasSexto/Sesion6/Lectura": [
		97885
	],
	"./LecturasSexto/Sesion7/Lectura": [
		14856
	],
	"./LecturasSexto/Sesion8/Lectura": [
		55535
	],
	"./LecturasSexto/Sesion9/Lectura": [
		98090
	],
	"./LecturasTercero/Sesion10/Lectura": [
		88535
	],
	"./LecturasTercero/Sesion11/Lectura": [
		84978
	],
	"./LecturasTercero/Sesion12/Lectura": [
		14097
	],
	"./LecturasTercero/Sesion13/Lectura": [
		43292
	],
	"./LecturasTercero/Sesion14/Lectura": [
		50179
	],
	"./LecturasTercero/Sesion15/Lectura": [
		15134
	],
	"./LecturasTercero/Sesion16/Lectura": [
		70749
	],
	"./LecturasTercero/Sesion17/Lectura": [
		70408
	],
	"./LecturasTercero/Sesion18/Lectura": [
		99855
	],
	"./LecturasTercero/Sesion19/Lectura": [
		57642
	],
	"./LecturasTercero/Sesion20/Lectura": [
		64234
	],
	"./LecturasTercero/Sesion21/Lectura": [
		21679
	],
	"./LecturasTercero/Sesion21R/Lectura": [
		32119
	],
	"./LecturasTercero/Sesion22/Lectura": [
		77300
	],
	"./LecturasTercero/Sesion23/Lectura": [
		41897
	],
	"./LecturasTercero/Sesion24/Lectura": [
		96278
	],
	"./LecturasTercero/Sesion25/Lectura": [
		37851
	],
	"./LecturasTercero/Sesion26/Lectura": [
		51520
	],
	"./LecturasTercero/Sesion27/Lectura": [
		22709
	],
	"./LecturasTercero/Sesion28/Lectura": [
		56242
	],
	"./LecturasTercero/Sesion29/Lectura": [
		87223
	],
	"./LecturasTercero/Sesion3/Lectura": [
		86663
	],
	"./LecturasTercero/Sesion30/Lectura": [
		17273
	],
	"./LecturasTercero/Sesion31/Lectura": [
		2660
	],
	"./LecturasTercero/Sesion32/Lectura": [
		78847
	],
	"./LecturasTercero/Sesion33/Lectura": [
		48474
	],
	"./LecturasTercero/Sesion34/Lectura": [
		65285
	],
	"./LecturasTercero/Sesion35/Lectura": [
		91536
	],
	"./LecturasTercero/Sesion36/Lectura": [
		48011
	],
	"./LecturasTercero/Sesion37/Lectura": [
		28486
	],
	"./LecturasTercero/Sesion38/Lectura": [
		31489
	],
	"./LecturasTercero/Sesion39/Lectura": [
		30988
	],
	"./LecturasTercero/Sesion39R/Lectura": [
		45710
	],
	"./LecturasTercero/Sesion4/Lectura": [
		55384
	],
	"./LecturasTercero/Sesion40/Lectura": [
		2236
	],
	"./LecturasTercero/Sesion41/Lectura": [
		41361
	],
	"./LecturasTercero/Sesion42/Lectura": [
		52754
	],
	"./LecturasTercero/Sesion43/Lectura": [
		72119
	],
	"./LecturasTercero/Sesion44/Lectura": [
		44392
	],
	"./LecturasTercero/Sesion45/Lectura": [
		81213
	],
	"./LecturasTercero/Sesion46/Lectura": [
		77022
	],
	"./LecturasTercero/Sesion47/Lectura": [
		28963
	],
	"./LecturasTercero/Sesion48/Lectura": [
		96788
	],
	"./LecturasTercero/Sesion49/Lectura": [
		42153
	],
	"./LecturasTercero/Sesion5/Lectura": [
		46797
	],
	"./LecturasTercero/Sesion50/Lectura": [
		72363
	],
	"./LecturasTercero/Sesion51/Lectura": [
		4518
	],
	"./LecturasTercero/Sesion52/Lectura": [
		40613
	],
	"./LecturasTercero/Sesion53/Lectura": [
		99376
	],
	"./LecturasTercero/Sesion54/Lectura": [
		1119
	],
	"./LecturasTercero/Sesion55/Lectura": [
		570
	],
	"./LecturasTercero/Sesion56/Lectura": [
		51769
	],
	"./LecturasTercero/Sesion56R/Lectura": [
		57433
	],
	"./LecturasTercero/Sesion57/Lectura": [
		10596
	],
	"./LecturasTercero/Sesion58/Lectura": [
		4307
	],
	"./LecturasTercero/Sesion6/Lectura": [
		48910
	],
	"./LecturasTercero/Sesion7/Lectura": [
		34707
	],
	"./LecturasTercero/Sesion8/Lectura": [
		2980
	],
	"./LecturasTercero/Sesion9/Lectura": [
		39513
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 45432;
module.exports = webpackAsyncContext;